---
import type { Props as $, List } from "../lib/types";

export type Props = $<List>;
---

<ul data-portabletext-unknown="list"><slot /></ul>
